import axios from 'axios';

const token = process.env.REACT_APP_GENERATE_TOKEN;

export default axios.create({
  baseURL: process.env.REACT_APP_GENERATE_OP_ZAU,
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-type': 'application/json',
  },
});